export const ERROR_MESSAGES = {
  login: 'Your email and/or password do not match',
  updatePassWarn:
    'You need update your password because is the first time you are signing in',
};
